<template>
  <div v-if="this.$props.showModalVideoCall">
    <div id="modalVideoCall" :class="[$style.modal]" @blur="hideModal()">
      <div :class="[$style.modalContent]">
        <div :class="[$style.divClose]">
          <span :class="[$style.close]" @click="hideModal()">&times;</span>
        </div>
        <div :class="[$style.headerModal]">
          <PdsIcon name="info" fill="#0061a0" :width="60" :height="60" isPointer />
          <h2 :class="$style.text">
            Cambio de fondo mediante videollamada</h2>
        </div>
        <div :class="[$style.modalBody]">
          <p
          :class="[$style.textBody]"
          >
          Para realizar tu cambio de fondo,
          agenda una videollamada y recibe la asesoría necesaria para realizarlo.
        </p>
        </div>
        <div :class="$style.footerModal">
            <a @click="registerAnalytics()" :class="$style.buttonContinue"
            href="https://atencionvirtual.cuprum.cl/contact_button/seller/rToTO7hgqpmoIXNz4vKrPmXpKaISNB7BvqVMK8lF"
            target="_blank"
            >Agendar videollamada</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PdsIcon from '@vue-pds/icon';
import gtmRegister from '@/functions/analitics';
import constantsAnalytics from '@/config/constantsAnalytics';

export default {
  name: 'ModalVideoCall',
  components: {
    PdsIcon,
  },
  data() {
    return {
      active: true,
    };
  },
  props: {
    showModalVideoCall: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  methods: {
    hideModal() {
      this.$emit('disable', false);
    },
    registerAnalytics() {
      gtmRegister(constantsAnalytics.click.btnVideoLlamada, this);
    },
  },
};
</script>

<style lang="scss" scoped module>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding-top: 100px;
  overflow: auto;
  letter-spacing: normal;
  background-color: rgba(0, 0, 0, 0.4);
}

.colorText {
  margin-top: 30px;
  font-size: 24px;
  font-style: normal;
  color: #c00000;
  text-align: center;
}

.text {
  margin-top: 18px;
  font-size: 40px;
  font-style: normal;
  font-weight: lighter;
  line-height: 50px;
  text-align: center;
}

.textBody {
  margin-top: 32px;
  margin-bottom: 32px;
  font-size: 16px;
  font-weight: normal;
  line-height: 26px;
  text-align: initial;
}

.modalContent {
  box-sizing: border-box;
  max-width: 625px;
  padding: 24px 32px 64px 32px;
  margin: auto;
  color: #000000;
  background-color: #fefefe;
  border: 1px solid #c5c6c5;
  border-radius: 8px;
}

.divClose {
  text-align: right;

  .close {
    font-size: 36px;
    color: #333333;
  }

  .close:hover,
  .close:focus {
    color: #035fa4;
    text-decoration: none;
    cursor: pointer;
  }
}

.headerModal {
  margin: 0 32px;
  margin-bottom: 25px;
  color: #333333;
  text-align: center;
}

.modalBody {
  max-height: 510px;
  margin: 0 32px;
  text-align: center;
}

.overAuto {
  overflow: auto;
}

.overHidden {
  overflow: hidden;
}

.shadowHeader {
  box-shadow: rgba(0, 0, 0, 0.35) 0 11px 10px;
}

.shadowFooter {
  box-shadow: rgba(0, 0, 0, 0.35) 0 -11px 10px;
}

.footerModal {
  z-index: 2;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  background-color: #ffffff;

  .divLink {
    margin: 0 auto;

    .link {
      display: flex;
      width: 220px;
      margin: 0 auto 35px;
      text-align: center;

      .icon {
        padding-right: 7px;
      }
    }
  }

  .buttonContinue {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: 42px;
    padding: 6.5px 24px;
    color: #ffffff;
    background-color: #035fa4;
    border: none;
    border-radius: 25px;

    button {
      display: block;
    }
  }
}
</style>
